<div class="toggle-container">
    <button
      [disabled]="disabled"
      [class.active]="value === leftLabel"
      [class.inactive]="value === rightLabel"
      (click)="toggle(leftLabel)"
      class="toggle-button left-button">
      {{leftLabel}}
    </button>
    <button
      [disabled]="disabled"
      [class.active]="value === rightLabel"
      [class.inactive]="value === leftLabel"
      (click)="toggle(rightLabel)"
      class="toggle-button right-button">
      {{rightLabel}}
    </button>
  </div>
